import { MinusIcon } from "@chakra-ui/icons"
import { IconButton } from "@chakra-ui/react"
import { FunctionComponent, MouseEventHandler } from "react"
import { useTranslation } from "react-i18next"

type RemoveButtonProps = {
  ariaLabel?: string,
  onClick?: MouseEventHandler,
}
export const RemoveButton: FunctionComponent<RemoveButtonProps> = ({ ariaLabel, onClick }) => {
  const { t } = useTranslation();
  return (
    <IconButton
      aria-label={ariaLabel ?? t('components.removeButton.defaultAriaLabel')}
      variant={'outlineRound'}
      colorScheme={'gray'}
      size={'sm'}
      icon={<MinusIcon color={"gray.400"} />}
      onClick={onClick}
    />
  )
}